/*
 * THE NAME AND THE ADDRESSES, IN ONE PLACE.
 *
 * These were typed into four files, which is how a product ends up half
 * renamed: the sign in screen points at the new domain, the expired session
 * message still names the old one, and a contractor locked out at nine on a
 * Monday is told to go somewhere that no longer answers.
 *
 * TWO ORIGINS, ONE PRODUCT. The marketing site owns sign in, sign up, the
 * password reset and the money. The app is a subdomain of it and owns
 * everything after the login. They are separate origins on purpose, which is
 * also why a session does not simply carry from one to the other: see
 * lib/session.ts for how the handoff works.
 */

/** What the product is called, wherever a person reads it. */
export const BRAND = 'LightsOS'

/** The marketing site. Sign in, sign up, billing. */
export const SITE = 'https://lightsos.com'

/** The app itself. Everything after the login. */
export const APP = 'https://app.lightsos.com'

/** Bare host, for the places that show an address rather than link to one. */
export const SITE_HOST = 'lightsos.com'
